import { ILinkedServiceTypeMetadata } from 'app/extensibility/metadatas/resource-type/linked-service-type-metadata';

import { Metamodel } from 'app/model/base/model';
import { EloquaLinkedService } from 'app/model/linkedservice/eloqua.linkedservice';
import { EloquaCopySource } from 'app/model/pipeline/copysource/eloqua.copysource';
import { useEncryptedEndpointsRadioSwitch } from 'app/registries/linked-service/linked-service-shared-fields';
import { deprecatedConnectorDocLink } from 'app/shared/constants/links.const';
import { format } from 'app/shared/utils/string.util';

export const eloquaMetadata: ILinkedServiceTypeMetadata = {
    type: Metamodel.modelFor(EloquaLinkedService).name,
    displayName: format(stringResources.ModelName_DisplayTextLegacyTemplate, stringResources.Eloqua_DisplayText),
    linkedServiceKind: 'table',
    icon: {
        className: 'svg-i-100x100-Oracle'
    },
    warningMessage: stringResources.Connector_Legacy_IsDeprecatedWarning,
    warningMessageHyperlink: deprecatedConnectorDocLink,
    warningTooltip: stringResources.Connector_Legacy_IsDeprecatedHint,
    notShowInTypeSelection: true,
    isFirstClass: true,
    supportDatasetV2: true,
    category: ['ServicesApps'],
    copySinkTypes: [],
    copySourceTypes: [Metamodel.modelFor(EloquaCopySource).name],
    controls: [
        {
            type: 'textbox',
            bind: 'endpoint',
            label: stringResources.ModelName_Endpoint,
            required: true,
            description: stringResources.Eloqua_Endpoint_Description,
            descriptionLink: 'https://login.eloqua.com',
            validators: [
                { type: 'required', errorMessage: '' }
            ],
            isLabelVertical: true
        },
        {
            type: 'textbox',
            bind: 'username',
            label: stringResources.ModelName_UserName,
            placeholder: stringResources.Eloqua_Username_Placeholder,
            required: true,
            validators: [
                { type: 'required', errorMessage: '' }
            ],
            isLabelVertical: true
        },
        {
            type: 'dynamic-akv-switcher',
            bind: 'password',
            label: stringResources.ModelName_Password,
            child: {
                type: 'password',
                label: stringResources.ModelName_Password,
                required: true,
                isLabelVertical: true
            },
            validators: [
                { type: 'required', errorMessage: '' }
            ],
            description: format(stringResources.AzureKeyVaultSecretName_Tooltip_Template,
                format(stringResources.ModelName_LinkedServiceTemplate, stringResources.Eloqua_DisplayText),
                stringResources.ModelName_Password)
        },
        useEncryptedEndpointsRadioSwitch
    ]
};
